import {
  Button,
  Icon,
  InformationCard,
  Text,
  Unifree
} from '@yes.technology/react-toolkit'
import { useState } from 'react'
import { useTranslation } from 'react-i18n-lite'
import styled from 'styled-components'
import { PhotoMark } from './PhotoMarkingModal'

const ListWrapper = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0.5rem 0 0 0;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  max-height: 150px;
  overflow: auto;
  flex-shrink: 0;
`

const MarkItem = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const UnifreeWrapper = styled.div`
  flex: 1;
`

const StyledButton = styled(Button)`
  width: initial;
  flex: 0;
`

const ButtonRow = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 0.5rem;
`

type MarkListProps = {
  marks: PhotoMark[]
  onDelete?: (index: number) => void
}

const MarkList = ({ marks, onDelete }: MarkListProps) => {
  const { t } = useTranslation()
  const [pendingDeleteIndex, setPendingDeleteIndex] = useState<number | null>(
    null
  )

  if (marks.length === 0) return null

  const handleConfirmDelete = () => {
    if (pendingDeleteIndex !== null) {
      onDelete?.(pendingDeleteIndex)
      setPendingDeleteIndex(null)
    }
  }

  return (
    <>
      <ListWrapper>
        {marks.map((mark, index) => (
          <MarkItem key={index}>
            <UnifreeWrapper>
              <Unifree
                informational
                label={`ID | ${t(
                  'activity-document-photo.mark-photo.category'
                )}`}
                value={`#${index + 1} | ${mark.category.des}`}
                style={{ flex: 1 }}
              />
            </UnifreeWrapper>
            {onDelete && (
              <StyledButton
                impactClass='navigation'
                variant='secondary'
                onClick={() => setPendingDeleteIndex(index)}
                title={t('activity-document-photo.mark-photo.remove-mark')}
                heightClass='semiSmall'
                style={{
                  width: '32px',
                  marginLeft: '4px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}
              >
                <Icon iconName='Cleaner' icSize='small' />
              </StyledButton>
            )}
          </MarkItem>
        ))}
      </ListWrapper>

      {pendingDeleteIndex !== null && (
        <InformationCard
          isOpen={true}
          title={t('activity-document-photo.mark-photo.delete-mark-title')}
          close={() => setPendingDeleteIndex(null)}
          style={{
            width: '100%',
            maxWidth: '400px',
            position: 'fixed',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
            margin: 0,
            zIndex: 1200
          }}
        >
          <Text variant='label-02'>
            {t('activity-document-photo.mark-photo.delete-mark-body')}
          </Text>
          <ButtonRow>
            <Button onClick={handleConfirmDelete}>
              {t('activity-document-photo.mark-photo.confirm')}
            </Button>
            <Button
              variant='secondary'
              onClick={() => setPendingDeleteIndex(null)}
            >
              {t('activity-document-photo.mark-photo.cancel')}
            </Button>
          </ButtonRow>
        </InformationCard>
      )}
    </>
  )
}

export default MarkList
